
export default {
    loggedIn(state) {
        return state.isAuthenticated == true
    }
}